import { render, staticRenderFns } from "./UploadModelDialog.vue?vue&type=template&id=42dd28b1"
import script from "./UploadModelDialog.vue?vue&type=script&lang=js"
export * from "./UploadModelDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadModelDialog.vue?vue&type=style&index=0&id=42dd28b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports